import { Search, Star, MessageSquare, Zap, ArrowRight, Mail } from 'lucide-react';
import { BulletList } from '../components/UIComponents';

export function ReferenceSection() {
    return (
        <div className="space-y-8 mt-6">
            {/* ── Troubleshooting ── */}
            <section className="doc-section scroll-mt-20" id="troubleshooting">
                <div className="mb-3 pb-2 border-b border-white/10">
                    <h2 className="text-xl font-bold flex items-center gap-2.5 text-gray-100">
                        <Search className="text-gray-400" size={22} />
                        Troubleshooting
                    </h2>
                </div>
                <div className="space-y-2.5">
                    {[
                        { issue: 'Installation script not running', solution: 'Ensure PowerShell is opened as Administrator.' },
                        { issue: 'Agent not visible in portal', solution: 'Verify internet connectivity and firewall settings.' },
                        { issue: 'Installation blocked', solution: 'Temporarily disable antivirus or allow the installer.' },
                        { issue: 'Permission denied', solution: 'Use an administrator account.' },
                        { issue: 'Download/installer link not working', solution: 'Retry from the portal, confirm DNS/proxy settings, and ensure outbound HTTPS access is allowed.' },
                    ].map((item) => (
                        <div className="bg-gray-800 border border-white/5 rounded-xl p-4 hover:border-orange-500/30 transition-all shadow-sm" key={item.issue}>
                            <div className="text-[13px] font-bold text-red-400 mb-1.5 flex items-center gap-2">
                                <Zap size={14} /> {item.issue}
                            </div>
                            <div className="text-[13px] text-gray-200 flex items-start gap-2 ml-1">
                                <ArrowRight size={14} className="text-green-500 shrink-0 mt-0.5" />
                                <span>{item.solution}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── Best Practices ── */}
            <section className="doc-section scroll-mt-20" id="best-practices">
                <div className="mb-3 pb-2 border-b border-white/10">
                    <h2 className="text-xl font-bold flex items-center gap-2.5 text-gray-100">
                        <Star className="text-yellow-500" size={22} />
                        Best Practices
                    </h2>
                </div>
                <div className="bg-gradient-to-br from-gray-800 to-gray-800/50 border border-white/5 rounded-xl p-5 shadow-sm">
                    <BulletList items={[
                        'Always install the agent using administrator privileges',
                        'Ensure stable internet connectivity during online installation',
                        'Keep the agent updated to the latest version',
                        'Verify endpoint firewall rules allow communication with the Ovul Scanner server'
                    ]} />
                </div>
            </section>

            {/* ── Support ── */}
            <section className="doc-section scroll-mt-20" id="support">
                <div className="mb-3 pb-2 border-b border-white/10">
                    <h2 className="text-xl font-bold flex items-center gap-2.5 text-gray-100">
                        <MessageSquare className="text-pink-400" size={22} />
                        Support
                    </h2>
                </div>
                <div className="bg-gradient-to-br from-gray-800 to-gray-800/50 border border-white/5 rounded-xl p-5 shadow-sm">
                    <div className="text-[14px] font-bold text-gray-100 mb-2 flex items-center gap-2">
                        <Mail size={16} className="text-pink-400" /> Contact Ovul Scanner Support
                    </div>
                    <div className="text-[13px] text-gray-200 mt-2.5 leading-relaxed">
                        For additional support or troubleshooting assistance, contact the Ovul Scanner Support Team at{' '}
                        <a href="mailto:contact@runnerssoftware.com" className="text-orange-400 hover:text-orange-300 transition-colors inline-block ml-1">contact@runnerssoftware.com</a>.
                    </div>
                </div>
            </section>
        </div>
    );
}
